/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from 'react';
import ReactDOM from "react-dom";
import {Button} from "@blueprintjs/core";
import {Card, Elevation} from "@blueprintjs/core";
import {Callout} from "@blueprintjs/core";
import {Intent, Toaster} from "@blueprintjs/core/lib/esm/index";
import {IconNames} from "@blueprintjs/icons";
import {WrcForm} from "./WrcForm.js"
import WrcRecordDetail from "./WrcRecordDetail.js"
import {WrcServer} from "./WrcServer.js";

export class WrcFind extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_loaded: false,
            value_to_find: "",
            record_found: null
        };
    }

    componentDidMount() {
        if (this.props.config.record_id === undefined) {
            this.setState({
                is_loaded: true});
        }
        else {
            this.postFind("id", this.props.config.record_id);
        }
    }

    render() {
        if (this.state.is_loaded) {
            let find_section = (
                <Card interactive={false} elevation={Elevation.ZERO} className='wd-card-m-top'>
                    {this.props.label} <input type="text" value={this.state.value_to_find} onChange={this.handleInputChange} />
                    <Button
                            icon={IconNames.SEARCH}
                            intent={Intent.PRIMARY}
                            text={'Find ' + this.props.entity}
                            onClick={(e) => this.find(e)} />
                    <div className="wd-record">
                        <Button
                                intent={Intent.PRIMARY}
                                text={'New ' + this.props.entity}
                                style={{marginTop: '1em'}}
                                fill={false}
                                onClick={() => this.showForm()} />
                    </div>
                </Card>
            );

            let details = null;
            if (this.state.data !== undefined) {
                if (this.state.data.id === undefined) {
                    details = (
                        <Card interactive={false} elevation={Elevation.ZERO} className='wd-card-m-top'>
                            <Callout intent={Intent.WARNING} title='No record found' style={{minWidth: 500}}>Try searching for a different value.</Callout>
                        </Card>
                    );
                }
                else {
                    details = (
                        <WrcRecordDetail
                                record={this.state.data}
                                component_index={this.props.component_index}
                                configure_component={this.props.configure_component}
                                config={this.props.config}
                                refresh={this.props.refresh}
                                entity={this.props.entity}
                                form_id={this.props.form_id}
                                table_schema={this.props.table_schema}
                                table_name={this.props.table_name}
                                columns={this.props.columns}
                                detail_buttons={this.props.detail_buttons}
                                children={this.props.children}
                                child_list_data={this.state.child_list_data}
                                local_id={this.props.local_id}
                        />
                    );
                }
            }

            return (
                <table className="layout-table">
                    <tbody>
                        <tr>
                            <td>
                                {find_section}
                            </td>
                            <td>
                                {details}
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
        }
        else {
            return (<div>Loading...</div>);
        }
    }

    find(e) {
        if (this.state.value_to_find === '') {
            Toaster.create().show({message: 'You must enter a value to search for.', intent: Intent.WARNING});
            return false;
        }
        this.postFind(this.props.field_name, this.state.value_to_find);
    }

    getData(content) {
        this.props.configure_component(this.props.component_index, {record_id: content['id']});
        this.setState({
            is_loaded: true,
            data: content,
            child_list_data: [],
            current_tab: 'tab1'});
    }

    handleInputChange = (event) => {
        event.persist();
        this.setState({value_to_find: event.target.value});
    }

    postFind(column_name, column_value) {
        let post = {table_schema: this.props.table_schema, table_name: this.props.table_name, column_name, column_value};
        let additional_columns = this.props.columns.filter((column)=> column.formula !== undefined)
        if (additional_columns.length > 0) {
            post.additional_columns = additional_columns;
        }

        WrcServer.post('find-record',
            post,
            (content) => this.getData(content)
        );
    }

    showForm() {
        ReactDOM.render(
            <WrcForm
                    form_id={this.props.form_id}
                    refresh={this.props.refresh}
                    component_index={this.props.component_index}
                    configure_component={this.props.configure_component} />,
            document.querySelector('#form'));
    }
}

export default WrcFind;
